import { Component } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ActivityAreaService } from "../core/service/activity-area.service";
import { ActivityArea } from "../core/model/activity-area";

@Component({
  selector: "app-activity-area",
  templateUrl: "./activity-area.component.html",
  styleUrls: ["./activity-area.component.scss"],
})
export class ActivityAreaComponent {
  activityareas: ActivityArea[];

  constructor(
    private _router: Router,
    private _activityAreaService: ActivityAreaService
  ) {}

  ngOnInit() {
    this.getActivityAreas();
  }

  getActivityAreas() {
    this._activityAreaService.getAllSecteurs().subscribe(
      (data) => {
        this.activityareas = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  add(): void {
    this._router.navigate(["/parametrage/activity-area/add-activity-area"]);
  }
}
